/** Concurrent refreshes share one run, then catch up to the latest request. */
export function coalescedRefresh<T>(read: () => Promise<T>): () => Promise<T> {
  let running: Promise<T> | null = null;
  let requested = 0;

  async function drain(): Promise<T> {
    for (;;) {
      const revision = requested;
      try {
        const result = await read();
        if (revision === requested) {
          running = null;
          return result;
        }
      } catch (error) {
        if (revision === requested) {
          running = null;
          throw error;
        }
      }
    }
  }

  return () => {
    requested++;
    running ??= Promise.resolve().then(drain);
    return running;
  };
}
